<template>
  <div
    :class="{
    'input-lancar-notas': true,
    'lancar-notas-error': exibirError(),
    'lancar-notas-pulsar': exibirError(),
    'lancar-notas-loading': loading,
  }"
  >
    <select
      ref="select"
      :disabled="disabled || loading"
      :value="value"
      @click="$emit('click')"
      @change="onChange"
      @keypress="event => $emit('keypress', event)"
      @keydown="stopArrowsAction"
    >
      <option
        v-for="op in optionsConceito"
        :key="op.key"
        :selected="value == op.value"
        :value="op.value"
        :title="op.title"
      >{{ op.text }}</option>
    </select>

    <div class="input-lancar-notas-disabled"></div>
    <!-- <div class="lancar-notas-loading-front" v-if="loading"></div> -->
    <div v-if="exibirError()" class="lancar-notas-tooltip-error">
      <div class="lancar-notas-error-bloco">
        <ul v-for="(msgError, index) in showErros" :key="index">
          <li>{{msgError}}</li>
        </ul>
      </div>
    </div>
    <!-- <div v-if="exibirError()" class="lancar-notas-tooltip-error">
      <div class="lancar-notas-error-bloco">
        <ul v-for="msgError in msgArrayError" :key="msgError.id">
          <li>{{msgError}}</li>
        </ul>
      </div>
    </div>-->
    <v-icon class="select-conceito-icon-right">arrow_drop_down</v-icon>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const DiarioEscolarRepository = RepositoryFactory.get("diarioEscolar");

export default {
  name: "SelectLancarConceito",
  props: {
    showErros: Array,
    value: [String, Number],
    index: [String, Number],
    aaletivo: [String, Number],
    cdturma: [String, Number],
    cddiscipl: [String, Number],
    numatalun: [String, Number],
    cdpessoal: [String, Number],
    cdmatric: [String, Number],
    cdtipesc: [String, Number],
    cdescola: [String, Number],
    identificadordistribuirconceit: [String, Number],
    disabled: {
      type: Boolean,
      default: false,
    },
    optionsConceito: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      msgArrayError: [],
      loading: false,
      valor: null,
    };
  },
  created() {
    this.addValue();
  },
  watch: {
    value() {
      this.addValue();
    },
  },
  methods: {
    // getShowErros() {
    //   return this.showErros ? this.showErros : [];
    // },
    addValue() {
      this.valor = this.value;
    },
    exibirError() {
      return this.showErros.length > 0;
    },
    // exibirError() {
    //   this.msgArrayError = [...this.msgArrayError, ...this.getShowErros()];

    //   return this.msgArrayError.length > 0;
    // },
    onChange(event) {
      this.valor = event.target.value;
      this.onBlur();
    },
    stopArrowsAction(event) {
      if (event.keyCode === 38 || event.keyCode === 40) {
        event.preventDefault();
      }
    },
    async onBlur() {
      if (this.valor === "") {
        this.valor = null;
      }

      const form = {
        aaletivo: this.aaletivo,
        cdtipesc: this.cdtipesc,
        cdescola: this.cdescola,
        cdturma: this.cdturma,
        cddiscipl: this.cddiscipl,
        numatalun: this.numatalun,
        cdpessoal: this.cdpessoal,
        cdmatric: this.cdmatric,
        identificadordistribuirconceit: this.identificadordistribuirconceit,
        identificadorconceito: this.valor,
      };

      this.$emit("input", this.valor);
      this.$emit("submitted", { index: this.index, valor: this.valor });
      this.$emit("nota", { index: this.index, nota: form });
    },
    // async onBlur() {
    //   this.msgArrayError = [];
    //   if (this.valor === "") {
    //     this.valor = null;
    //   }

    //   const form = {
    //     aaletivo: this.aaletivo,
    //     cdtipesc: this.cdtipesc,
    //     cdescola: this.cdescola,
    //     cdturma: this.cdturma,
    //     cddiscipl: this.cddiscipl,
    //     numatalun: this.numatalun,
    //     cdpessoal: this.cdpessoal,
    //     cdmatric: this.cdmatric,
    //     identificadordistribuirconceit: this.identificadordistribuirconceit,
    //     identificadorconceito: this.valor,
    //   };

    //   this.loading = true;
    //   const oldValor = this.value;
    //   this.$emit("input", this.valor);
    //   try {
    //     // const response = await DiarioEscolarRepository.postLancarConceito(form);

    //     this.$emit("input", this.valor);
    //     this.$emit("submitted", { index: this.index, valor: this.valor });
    //     this.$emit("nota", { index: this.index, nota: form });
    //   } catch (error) {
    //     if (
    //       error.response &&
    //       error.response.data.status == "ERROR_BUSINESS_RULE"
    //     ) {
    //       //this.msgArrayError = error.response.data.errorMessage;
    //       this.msgArrayError = [error.response.data.errorMessage];
    //     } else {
    //       this.msgArrayError = ["Ocorreu um erro! Tente Novamente."];
    //     }
    //     this.$emit("input", oldValor);
    //     throw error;
    //   } finally {
    //     this.loading = false;
    //   }
    // },
  },
};
</script>

<style lang="scss">
.input-lancar-notas {
  width: 70px;
  height: 30px;
  border-radius: 4px;
  display: inline-flex;
  position: relative;
  z-index: 0;

  select {
    color: black;
    display: flex;
    border: none !important;
    background-color: transparent;
    z-index: 1;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-size: 1rem;
    line-height: 1.75rem;
    font-weight: 400;
    letter-spacing: 0.00937em;
    text-decoration: inherit;
    text-transform: inherit;
    -ms-flex-item-align: end;
    align-self: flex-end;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    border-radius: 0;
    -webkit-appearance: none;
    text-align: center;
    padding-left: 30px;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    &:focus {
      outline: none;
      & + .input-lancar-notas-disabled {
        border-width: 2px;
        border-color: #009688;
      }
    }

    &:disabled + .input-lancar-notas-disabled {
      background-color: #94949424;
    }

    &:hover ~ .lancar-notas-tooltip-error {
      display: block;
      margin-top: 32px;
      opacity: 1;
    }
  }

  .select-conceito-icon-right {
    position: absolute;
    top: 6%;
    right: -3%;
  }

  .input-lancar-notas-disabled {
    width: 100%;
    height: 100%;
    position: absolute;
    border-radius: 4px;
    border: 1px solid #757575;
    -webkit-transition: all 0.1s ease-out;
    -moz-transition: all 0.1s ease-out;
    -o-transition: all 0.1s ease-out;
    transition: all 0.1s ease-out;
  }

  .lancar-notas-tooltip-error {
    min-width: 150px;
    position: absolute;
    z-index: 2;
    //margin-left: calc(-100%);
    margin-top: 23px;
    -webkit-transition: all 0.2s ease-out;
    -moz-transition: all 0.2s ease-out;
    -o-transition: all 0.2s ease-out;
    transition: all 0.2s ease-out;
    opacity: 0;
    display: block;
    text-align: left;

    .lancar-notas-error-bloco {
      background: #e22e2ed9;
      border-radius: 2px;
      color: #fff;
      font-size: 12px;
      display: inline-block;
      //display: block;
      padding: 5px 8px;
      text-transform: initial;
      width: auto;
      box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
        0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);

      ul {
        list-style-type: none;
      }
    }
  }
}

.lancar-notas-error .input-lancar-notas-disabled {
  border-color: #b00020 !important;
  border-width: 2px;
}

.lancar-notas-pulsar {
  animation: pulsar 2s;
}

.lancar-notas-loading-front {
  border: 2px solid green !important;
  box-sizing: border-box;
  border-width: 2px;
  animation: clipMe 1s infinite;
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 4px;
}

@keyframes pulsar {
  0%,
  40%,
  80% {
    opacity: 0;
  }
  20%,
  60%,
  100% {
    opacity: 1;
  }
}

@keyframes loading {
  to {
    stroke-dashoffset: -5;
  }
}

@keyframes clipMe {
  0%,
  100% {
    clip: rect(0px, 70px, 2px, 0px);
  }
  25% {
    clip: rect(0px, 70px, 30px, 67px);
  }
  50% {
    clip: rect(27px, 70px, 30px, 0px);
  }
  75% {
    clip: rect(0px, 2px, 30px, 0px);
  }
}
</style>
